import React from "react";
import PropTypes from "prop-types";

export default function ExternalLink({ url, children, style = {} }) {
  if (!url) {
    return false;
  }

  const href = url.match(/^(http|https):\/\//i) ? url : `http://${url}`;

  return (
    <a href={href} rel="noopener noreferrer" target="_blank" style={style}>
      {children || url}
    </a>
  );
}

ExternalLink.propTypes = {
  url: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ])
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/ExternalLink/ExternalLink.jsx